import { render, staticRenderFns } from "./DivReset.vue?vue&type=template&id=fdef3ef2&scoped=true&lang=pug&"
import script from "./DivReset.vue?vue&type=script&lang=ts&"
export * from "./DivReset.vue?vue&type=script&lang=ts&"
import style0 from "./DivReset.vue?vue&type=style&index=0&id=fdef3ef2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef3ef2",
  null
  
)

export default component.exports